import { cn } from "@core-ui/utils/cn";
import type { ReactNode } from "react";

interface MediaAnimationProps {
	isClosing: boolean;
	children: ReactNode;
	className?: string;
}

export const MediaAnimation = (props: MediaAnimationProps) => {
	const { isClosing, className, children } = props;

	return (
		<div className={cn("absolute left-0 top-0 z-[var(--z-index-ui-kit-modal)] h-dvh w-dvw select-none", className)}>
			<div
				className={cn(
					"relative h-full w-full duration-200 fill-mode-forwards",
					isClosing ? "animate-out fade-out-0" : "animate-in fade-in-0",
				)}
				data-close="true"
			>
				{children}
			</div>
		</div>
	);
};
